<template>
  <v-card>
    <v-card-title>{{ $t('pages.servicecreation.title') }}</v-card-title>
    <v-card-text>
      <service-form :service="service"></service-form>
    </v-card-text>
  </v-card>
</template>

<script>
  import { ServiceForm } from '@/components/service'
  export default {
    components: {
      ServiceForm
    },
    computed: {
      service () {
        return {}
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/ServiceCreation.vue